import React from 'react';

const Team = () => {
  return (
    <div className="team-page">
      <div className="container">
        <h1>The Team</h1>
        <p>This is the team page. Content will be added here.</p>
      </div>
    </div>
  );
};

export default Team;
